export default {
  image: null,
};
